import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-jobs-page-header',
  templateUrl: './jobs-page-header.component.html',
  styleUrls: ['./jobs-page-header.component.scss']
})
export class JobsPageHeaderComponent implements OnInit {

  @Input() jobNumber: string;

  constructor() { }

  ngOnInit(): void {
  }

}
